module.exports = __webpack_public_path__ + "img/drachenmakiganzweiss.5084a1c6.jpg";